import { h, Component } from 'preact';
import { showEditCapacityModal } from 'utils/editCapacityModal';
import { trackGAEvent } from 'utils/track';
import Store from 'store/store';

import TheaterInfo from 'components/theaterInfo/theaterInfo';
import CapacityInfo from 'components/capacityInfo/capacityInfo';
import IconSearch from 'components/icons/search';
import IconScan from 'components/icons/scan';
import IconEdit from 'components/icons/edit';

import s from 'components/main/main.scss';

export default class Main extends Component {
	constructor(props) {
		super(props);
		this.goToSearch = this.goToSearch.bind(this);
		this.goToScan = this.goToScan.bind(this);
		this.editCapacity = this.editCapacity.bind(this);
	}

	goToSearch() {
		trackGAEvent('landing-search-cta', 'search', '');
		this.props.goTo?.('search');
	}
	goToScan() {
		trackGAEvent('landing-scan-cta', 'search', '');
		this.props.goTo?.('scan');
	}

	async editCapacity() {
		const data = await showEditCapacityModal({ capacity: this.props.screening.capacity });
		if (data?.capacity != null) {
			trackGAEvent('capacity-edit-cta', 'seatCapacity', '');
			trackGAEvent('capacity-amount-edit', 'seatCapacity', `${data.capacity}`);
			Store.get().screening.set('capacity', data.capacity);
			trackGAEvent('capacity-update-cta', 'seatCapacity', `${data.capacity}`);
		}
	}

	render(props) {
		const { theater, movie, screening, tickets, offline } = props;

		return (
			<div class={s.root}>
				<TheaterInfo theater={theater} movie={movie} screening={screening} />
				<div class={s.capacityWrapper}>
					<CapacityInfo screening={screening} tickets={tickets} offline={offline} />
					<div class={s.editContainer}>
						<button class={s.edit} onClick={this.editCapacity}>
							<IconEdit />
							Edit
						</button>
					</div>
					<div class={s.totalTickets}>
						Total tickets issued: {tickets?.length || 0}
					</div>
				</div>
				<div class={s.modes}>
					<button class={s.mode} onClick={this.goToSearch}>
						<IconSearch class={s.icon} />
						Search
					</button>
					<button class={s.mode} onClick={this.goToScan}>
						<IconScan class={s.icon} />
						Scan
					</button>
				</div>
			</div>
		);
	}
}